import {
  IoEyeOffOutline,
  IoFlameOutline,
  IoPricetagOutline,
  IoRocketOutline,
  IoSparklesOutline,
  IoCloseCircleOutline,
} from 'react-icons/io5';
import styles from './ProductCard.module.css';

interface ProductBadgesProps {
  productId?: number;
  hasDiscount: boolean;
  isPopular?: boolean;
  isNew?: boolean;
  isHidden?: boolean;
  isOutOfStock?: boolean;
  promotionEnabled?: boolean;
  customSets?: Array<{
    id: number;
    name: string;
  }>;
  direction?: 'row' | 'column';
  onPopularClick?: () => void;
  onHiddenClick?: () => void;
}

export default function ProductBadges({
  hasDiscount,
  isPopular,
  isNew,
  isHidden,
  isOutOfStock,
  promotionEnabled,
  direction = 'column',
}: ProductBadgesProps) {
  return (
    <div
      className={styles.productCardBadges}
      style={{ flexDirection: direction }}
    >
      {promotionEnabled ? (
        <span
          className={`${styles.productCardBadge} ${styles.productCardBadgePromotion}`}
          onClick={(e) => e.stopPropagation()}
        >
          <IoRocketOutline size={12} aria-hidden />
          продвижение
        </span>
      ) : null}
      {hasDiscount ? (
        <span
          className={`${styles.productCardBadge} ${styles.productCardBadgeSale}`}
          onClick={(e) => e.stopPropagation()}
        >
          <IoPricetagOutline size={12} aria-hidden />
          акция
        </span>
      ) : null}
      {isPopular ? (
        <span
          className={`${styles.productCardBadge} ${styles.productCardBadgePopular}`}
          onClick={(e) => e.stopPropagation()}
        >
          <IoFlameOutline size={12} aria-hidden />
          популярное
        </span>
      ) : null}
      {isNew ? (
        <span
          className={`${styles.productCardBadge} ${styles.productCardBadgeNew}`}
          onClick={(e) => e.stopPropagation()}
        >
          <IoSparklesOutline size={12} aria-hidden />
          новинка
        </span>
      ) : null}
      {isHidden ? (
        <span
          className={`${styles.productCardBadge} ${styles.productCardBadgeHidden}`}
          onClick={(e) => e.stopPropagation()}
        >
          <IoEyeOffOutline size={12} aria-hidden />
          скрыто
        </span>
      ) : null}
      {isOutOfStock ? (
        <span
          className={`${styles.productCardBadge} ${styles.productCardBadgeOut}`}
          onClick={(e) => e.stopPropagation()}
        >
          <IoCloseCircleOutline size={12} aria-hidden />
          нет в наличии
        </span>
      ) : null}
      {/* {customSets && customSets.length > 0
        ? customSets.map((customSet) => (
            <span
              key={customSet.id}
              className={styles.productCardBadge}
              title={customSet.name}
              onClick={(e) => e.stopPropagation()}
            >
              {customSet.name}
            </span>
          ))
        : null} */}
    </div>
  );
}
